<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <hotel-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import HotelForm from "./Form"
import model from "./model"

export default {
  components: { HotelForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
